import { ref, get, set } from 'firebase/database';
import { database } from '../firebaseConfig';

// Points and streaks for finishing transaction tasks. Stored per person at users/{uid}/gamification.
// Points: 10 per task (5 for notifications sent by hand), plus 5 if it was finished on or before its due date.
// Streak: consecutive days with at least one completed task.

const todayStr = () => new Date().toISOString().slice(0, 10);

const dayDiff = (a, b) => {
  const da = new Date(`${a}T00:00:00`);
  const db = new Date(`${b}T00:00:00`);
  return Math.round((db - da) / 86400000);
};

export const getStats = async (uid) => {
  try {
    const snap = await get(ref(database, `users/${uid}/gamification`));
    const v = snap.exists() ? snap.val() : {};
    return { points: v.points || 0, streak: v.streak || 0, lastDoneDate: v.lastDoneDate || null };
  } catch (err) {
    console.error('Could not load gamification stats', err);
    return { points: 0, streak: 0, lastDoneDate: null };
  }
};

// Awards points for one completed task and updates the streak. Returns what was earned.
export const awardForTask = async (uid, task) => {
  const stats = await getStats(uid);
  const today = todayStr();
  const base = task.type === 'Notification' ? 5 : 10;
  const onTime = !task.dueDate || task.dueDate >= today;
  const earned = base + (onTime ? 5 : 0);

  let streak = stats.streak;
  if (!stats.lastDoneDate) streak = 1;
  else {
    const gap = dayDiff(stats.lastDoneDate, today);
    if (gap === 0) streak = Math.max(stats.streak, 1);
    else if (gap === 1) streak = stats.streak + 1;
    else streak = 1;
  }

  const next = { points: stats.points + earned, streak, lastDoneDate: today };
  try {
    await set(ref(database, `users/${uid}/gamification`), next);
  } catch (err) {
    console.error('Could not save gamification stats', err);
  }
  return { earned, onTime, ...next };
};
